import type { TOC } from '@ember/component/template-only';

import styles from './overlay-with-message.module.css';

export interface GeneralOverlayWithMessageSignature {
  Args: { message: string };
}

<template>
  <div class={{styles.message-overlay}}>
    <div class={{styles.message-wrapper}}>
      {{@message}}
    </div>
  </div>
</template> satisfies TOC<GeneralOverlayWithMessageSignature>;
